import {Box, Label, Stack, Text} from '@primer/react-brand'
import type {IndexFilter} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import styles from './ResourceDetailsPage.module.css'
import {appendFeatureFlagsToUrl} from '../../lib/utils'
import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

type TagsProps = {
  tagsLabel: string
  indexPath: string
  tags: IndexFilter[]
}

export const Tags = ({tagsLabel, indexPath, tags}: TagsProps) => {
  const queryParams = new URLSearchParams(ssrSafeLocation.search)
  const featureFlags = queryParams.get('_features') || ''
  return (
    <Box
      className={styles.tagsWrapper}
      paddingBlockStart={40}
      paddingBlockEnd={40}
      borderBlockEndWidth="thin"
      borderColor="muted"
      borderStyle="solid"
    >
      <Stack direction="horizontal" padding="none" flexWrap="wrap">
        <Text>{tagsLabel}</Text>
        {tags.map(tag => {
          const url = new URL(indexPath, ssrSafeLocation.origin)
          url.searchParams.set(encodeURIComponent(tag.fields.groupValue), encodeURIComponent(tag.fields.filterValue))
          const href = appendFeatureFlagsToUrl(url.toString(), featureFlags)
          return (
            <a
              href={href}
              key={`${tag.sys.id}-${tag.fields.filterValue}`}
              aria-label={`${tagsLabel}: ${tag.fields.filterName}`}
              data-testid={`resource-details-tag-link-${tag.fields.filterName}`}
              {...getAnalyticsEvent({
                action: tag.fields.filterName,
                tag: 'hyperlink',
                context: 'tags',
                location: 'resource_details_footer',
              })}
            >
              <Label>{tag.fields.filterName}</Label>
            </a>
          )
        })}
      </Stack>
    </Box>
  )
}

try{ Tags.displayName ||= 'Tags' } catch {}